import type { RoundFeedCard } from "../../shared/contracts/round-feed.js";
import type { ResultCard } from "./result-card.js";
import { posterDate } from "../../shared/presentation/round-poster-score.js";

export function posterShareCard(
  round: RoundFeedCard,
  avatarUrls: Record<string, string | null>,
): ResultCard {
  if (round.underReview)
    throw new Error("Finish and review the round before sharing its result.");
  const url = `https://fairwayrivalry.com/rounds?result=${encodeURIComponent(round.roundId)}`;
  const scores = round.sides
    .map((side) => {
      if (round.kind === "match") return side.name;
      const value =
        round.kind === "stroke" && side.participantIds.length === 1
          ? side.incompleteStrokes
            ? null
            : side.strokes
          : (side.valueLabel ?? side.value);
      return `${side.name}: ${value ?? "—"} ${round.kind === "stroke" ? "strokes" : round.kind === "stableford" ? "points" : ""}${round.kind === "stroke" && round.basis === "net" ? ` (${side.value ?? "—"} net)` : ""}`;
    })
    .join(" · ");
  const story = [
    round.stakeStory,
    round.story?.impact,
    round.story?.record,
    round.story?.basis,
    round.story?.turningPoint,
  ]
    .filter(Boolean)
    .join(" ");
  return {
    poster: { round, avatarUrls, url },
    eyebrow: round.format,
    headline: round.outcome,
    scoreline: round.scoreline,
    scoreNote: story || null,
    detail: round.courseName,
    accent: "#c9a961",
    fileName: `fairway-rivalry-${round.roundId}.png`,
    text: `${scores}${round.kind === "match" ? ` · ${round.scoreline}` : ""}. ${round.outcome}. ${round.courseName} · ${posterDate(round)}. ${story}\nOpen the scorecard (sign-in and access required): ${url}`,
  };
}
